module.exports = __webpack_public_path__ + "img/smiley-01.a3fdd7e6.png";